<!-- TEMPLATE CONTRACT: Ui Document Upload Component owns the visible Angular template structure for src/app/shared/ui/ui-document-upload/ui-document-upload.component.html. -->
<input
  #fileInput
  type="file"
  [multiple]="multiple()"
  [accept]="accept() || null"
  [disabled]="disabled()"
  class="ui-document-upload__input"
  (change)="onFileSelected($event)"
/>

<div
  class="ui-document-upload__dropzone"
  [class.ui-document-upload__dropzone--active]="dropActive()"
  [class.ui-document-upload__dropzone--busy]="pendingDocuments().length > 0"
  [class.ui-document-upload__dropzone--disabled]="disabled()"
  role="button"
  [attr.tabindex]="disabled() ? -1 : 0"
  [attr.aria-disabled]="disabled()"
  [attr.aria-label]="dropLabel() | translate"
  (click)="!disabled() && fileInput.click()"
  (keydown.enter)="!disabled() && fileInput.click()"
  (keydown.space)="!disabled() && fileInput.click(); $event.preventDefault()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <span class="material-symbols-rounded ui-document-upload__dropzone-icon" aria-hidden="true">upload_file</span>
  <span class="ui-document-upload__dropzone-label">{{ dropLabel() | translate }}</span>
</div>

<!-- Conditional branch documents the visible UI state for this condition. -->
@if (pendingDocuments().length > 0) {
  <div class="ui-document-upload__list">
    <!-- Repeated block documents how collection data renders in the UI. -->
    @for (pendingDoc of pendingDocuments(); track pendingDoc.id) {
      <article class="ui-document-upload__card ui-document-upload__card--pending">
        <div class="ui-document-upload__file">
          <span class="material-symbols-rounded ui-document-upload__file-icon" aria-hidden="true">
            {{ fileIcon(pendingDoc.type) }}
          </span>
          <span class="ui-document-upload__file-name">{{ pendingDoc.name }}</span>
        </div>
        <div class="ui-document-upload__footer">
          <span class="ui-document-upload__tag">{{ pendingLabel() | translate }}</span>
        </div>
      </article>
    }
  </div>
}

<!-- Conditional branch documents the visible UI state for this condition. -->
@if (documents().length > 0) {
  <div class="ui-document-upload__list">
    <!-- Repeated block documents how collection data renders in the UI. -->
    @for (doc of documents(); track doc.id) {
      <article class="ui-document-upload__card">
        <div class="ui-document-upload__file">
          <span class="material-symbols-rounded ui-document-upload__file-icon" aria-hidden="true">
            {{ fileIcon(doc.type) }}
          </span>
          <span class="ui-document-upload__file-name">{{ doc.name }}</span>
        </div>
        <span class="ui-document-upload__tag">
          {{ (doc.type === 'image' ? imageLabel() : documentLabel()) | translate }}
        </span>
        <div class="ui-document-upload__actions">
          <button
            class="ui-document-upload__action"
            type="button"
            [attr.aria-label]="previewActionLabel() | translate: { name: doc.name }"
            (click)="previewDocument.emit(doc)"
          >
            <span class="material-symbols-rounded" aria-hidden="true">visibility</span>
          </button>
          <button
            class="ui-document-upload__action"
            type="button"
            [attr.aria-label]="downloadActionLabel() | translate: { name: doc.name }"
            (click)="downloadDocument.emit(doc)"
          >
            <span class="material-symbols-rounded" aria-hidden="true">download</span>
          </button>
          <button
            class="ui-document-upload__action"
            type="button"
            [attr.aria-label]="removeActionLabel() | translate: { name: doc.name }"
            (click)="removeDocument.emit(doc.id)"
          >
            <span class="material-symbols-rounded" aria-hidden="true">close</span>
          </button>
        </div>
      </article>
    }
  </div>
}
